import { useEffect, useRef, useState } from 'react';
import { api } from '../lib/api';

export function useCommunity() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const lastJsonRef = useRef('');

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        // Cache-bust so OBS/Chromium never serves a stale copy of the
        // community stats while a browser source stays open for hours.
        const r = await api.get('/community/overview', {
          params: { _t: Date.now() },
          headers: { 'Cache-Control': 'no-cache' },
        });
        if (!alive) return;
        // Only push a new state reference when the payload actually changed.
        // Without this every 45s poll would re-render the whole overlay
        // tree and briefly restart CSS animations (visible flicker in OBS).
        const serialised = JSON.stringify(r.data ?? null);
        if (serialised !== lastJsonRef.current) {
          lastJsonRef.current = serialised;
          setData(r.data);
        }
      } catch {
        // noop
      } finally {
        if (alive) setLoading(false);
      }
    };
    load();
    const id = setInterval(load, 45000);
    // Also refresh whenever the OBS scene becomes visible again — some OBS
    // set-ups throttle/pause background timers when a scene is off-screen.
    const onVis = () => { if (!document.hidden) load(); };
    document.addEventListener('visibilitychange', onVis);
    return () => {
      alive = false;
      clearInterval(id);
      document.removeEventListener('visibilitychange', onVis);
    };
  }, []);

  return { data, loading };
}
